var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"box-card mt-3",attrs:{"id":"special"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_c('h4',[_vm._v("Nổi bật")])])]),(_vm.infomation)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.infomation.special)}}):_c('div',[_vm._v("Chưa có tin nổi bật")])])
}
var staticRenderFns = []

export { render, staticRenderFns }